import React, { useState } from 'react';

import Button from '../../UI/Button/Button';
import './CourseInput.css';

const CourseInput = props => {
  const [enteredValue, setEnteredValue] = useState('');
  const [isValid, setIsValid] = useState(true);
  const goalInputChangeHandler = event => {
    setEnteredValue(event.target.value);
  };

  const formSubmitHandler = event => {
    event.preventDefault();
    if(enteredValue.trim().length === 0){
      setIsValid(false);
      return;
    }
    props.onAddGoal(enteredValue);
  };

  // const refresh = event => {
  //   window.location.reload();
  // }

  return (
    <React.Fragment>
    <form onSubmit={formSubmitHandler}>
      <div className="form-control">
        <label style={{color: !isValid ? 'red': 'black'}}>Course Goal</label>
        <input type="text" onChange={goalInputChangeHandler} disabled={!isValid} />
      </div>
      <Button type="submit">Add Goal</Button>
    </form>
    {/* <Button type="button" onClick={refresh} >Refresh</Button> */}
    </React.Fragment>
  );
};

export default CourseInput;
